import React, { Component } from 'react';
import './MovingAverageGraph.css';
import { t } from 'i18next';

import TimeSeriesGraph from './TimeSeriesGraph/TimeSeriesGraph';

class MovingAverageGraphMultivariate extends Component {
  render() {
    const { data } = this.props;
    return (
      <div className="board">
        {data && Object.keys(data).map((property) => (
          <div className="graph-row"
            key={property}
          >
            <div className="graph-row-content">
              <div className="graph-row-title">
                {`${property} ${t('tensorAnalytics.graphs.timeSeriesGraph.timeSeriesTitle')}`}
              </div>
              <TimeSeriesGraph data={data[property]}
                propertyText={property}
                yAxisTitle={`${property} ${t('tensorAnalytics.graphs.timeSeriesAxis')}`}
                colors={{
                  anomalyColor: '#ff4a4a',
                  areaColor: '#E5E5FE',
                  meanColor: '#e66000',
                  transformColor: '#D5B98B',
                }}
                labels={{
                  anomalyLabel: t('tensorAnalytics.graphs.timeSeriesGraph.anomalyDetected'),
                  areaLabel: t('tensorAnalytics.graphs.timeSeriesGraph.std'),
                  meanLabel: t('tensorAnalytics.graphs.timeSeriesGraph.mean'),
                  transformLabel: t('tensorAnalytics.graphs.timeSeriesGraph.transform'),
                }}
              />
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default MovingAverageGraphMultivariate;
